/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import simpleRestProvider from "ra-data-simple-rest";
import { fetchUtils } from "react-admin";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, getAccessTokenSilent, getAccountId } from "./authConfig";

const msalClient = new PublicClientApplication(msalConfig);

const httpClient = async (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }

  const accountId = getAccountId(msalClient);
  const token = await getAccessTokenSilent(msalClient, accountId);

  if (token) {
    options.headers.set("Authorization", `Bearer ${token.accessToken}`);
  }

  return fetchUtils.fetchJson(url, options);
};

const dataProvider = simpleRestProvider(
  `${process.env.REACT_APP_BACKEND_URI}/api`,
  httpClient
);

const customDataProvider = {
  ...dataProvider,
  getOne: (resource, params) => {
    let id = params.id;
    const data = params.data;
    if (data) {
      id = id + "?";
      for (const [key, value] of Object.entries(data)) {
        id = id + key + "=" + value + "&";
      }
    }
    return dataProvider.getOne(resource, { id });
  },
};

export default customDataProvider;
